export const defaultFontSize = "1.2rem"